import React from 'react';
import type { ViewProps } from 'react-native';

export default class View extends React.Component<ViewProps> {}
